<template>&nbsp;</template>
<script setup lang="ts">
definePage({
  redirect: { name: '/account/profile/' },
})
</script>
